import type Highcharts from "highcharts";
import type { Series } from "./options";

type PointWithValidity = Highcharts.PointOptionsObject & {
  custom: {
    x: { validity?: unknown };
    y: { validity?: unknown };
  };
};

const INVALID_VALIDITIES = new Set([
  "INVALID_AUTO",
  "INVALID_AUTO_CROSS_FILTER",
  "INVALID_MANUAL",
  "INVALID_INHERITED",
]);

export function isInvalidatedDataPoint(point: Highcharts.PointOptionsObject) {
  const custom = point.custom as PointWithValidity["custom"] | undefined;

  return (
    INVALID_VALIDITIES.has(String(custom?.x.validity)) ||
    INVALID_VALIDITIES.has(String(custom?.y.validity))
  );
}

export function applyInvalidatedDataPointsOption(
  series: Series[],
  displayInvalidatedDataPoints: boolean,
): Series[] {
  if (displayInvalidatedDataPoints) return series;

  return series.map((serie): Series => {
    const data = serie.data as PointWithValidity[];

    return {
      ...serie,
      data:
        serie.type === "scatter"
          ? data.filter(point => !isInvalidatedDataPoint(point))
          : data.map(point => (isInvalidatedDataPoint(point) ? { ...point, y: null } : point)),
    } as Series;
  });
}
